import { render, staticRenderFns } from "./conference-venue.vue?vue&type=template&id=559c9d70&scoped=true&"
import script from "./conference-venue.vue?vue&type=script&lang=js&"
export * from "./conference-venue.vue?vue&type=script&lang=js&"
import style0 from "./conference-venue.vue?vue&type=style&index=0&id=559c9d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c9d70",
  null
  
)

export default component.exports